const customerName = 'thbrowncomau';

let initializing = false;
let optionsListenerAttached = false;
let galleryObserver = null;
let refreshTimeouts = [];
let lastRequestedSKU = null;
let isRefreshingSKU = false;

const PLACEMENT_SELECTOR = 'slideshow-container[ref="slideshowContainer"]';
const COLOR_INPUT_SELECTOR =
    'variant-picker fieldset[data-option-position="1"] input[type="radio"]';

const waitForMazingFunction = new Promise((resolve) => {
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, 50);
});

const getButtonText = (translations) => {
    const lang = navigator.language || navigator.userLanguage || 'en';
    return translations[lang.split('-')[0]] || translations.en;
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split('/');
    const product = parts.filter(part => part.trim() !== '').pop();
    const baseSKU = product.split('?')[0].toLowerCase();

    const selectedColorInput = document.querySelector(
        `${COLOR_INPUT_SELECTOR}:checked`
    );

    const selectedColor =
        selectedColorInput?.value ||
        selectedColorInput?.getAttribute('aria-label') ||
        null;

    if (!selectedColor) {
        console.log('Final SKU:', baseSKU);
        return baseSKU;
    }

    const normalizedColor = selectedColor
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');

    const finalSKU = `${baseSKU}-${normalizedColor}`;

    console.log('Final SKU:', finalSKU);
    return finalSKU;
};

const clearScheduledRefreshes = () => {
    refreshTimeouts.forEach(timeout => clearTimeout(timeout));
    refreshTimeouts = [];
};

const refreshMazingSKU = async (reason = 'manual') => {
    if (typeof mazingRefreshSKU !== 'function') {
        console.warn('mazingRefreshSKU is not available.');
        return;
    }

    if (isRefreshingSKU) {
        console.log('Skipping refresh, already refreshing.');
        return;
    }

    const sku = getCurrentSKU();

    if (!sku) {
        console.warn('No SKU found.');
        return;
    }

    isRefreshingSKU = true;
    lastRequestedSKU = sku;

    try {
        console.log(`Refreshing Mazing SKU (${reason}):`, sku);
        await mazingRefreshSKU(sku, customerName);
    } catch (error) {
        console.error('refreshSKU failed:', error);
    } finally {
        isRefreshingSKU = false;
    }
};

const scheduleStableRefresh = () => {
    clearScheduledRefreshes();

    /**
     * Multiple refreshes are intentional:
     * Shopify themes often update product media/slideshows async after variant change.
     */
    [150, 400, 900, 1500].forEach(delay => {
        const timeout = setTimeout(() => {
            refreshMazingSKU(`scheduled-${delay}ms`);
        }, delay);

        refreshTimeouts.push(timeout);
    });
};

const initializeMazing = async () => {
    await mazing({
        customerName,
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    padding-left: 28px;
                    padding-right: 28px;
                    padding-bottom: 14px;
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index: 5;
                    justify-content: end;
                    pointer-events: auto;
                }

                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(100%);
                    width: fit-content !important;
                    margin: 0 !important;
                }

                .mazing-threed-btn,
                .mazing-ar-btn {
                    font-family: var(--button-font-family-primary);
                    font-weight: var(--button-font-weight-primary);
                    border-radius: 5px;
                    padding-inline: var(--padding-lg);
                    background: var(--color-primary-button-background);
                    box-shadow: none !important;
                    display: flex;
                    justify-content: space-around;
                    gap: 10px;
                    position: relative;
                    overflow: hidden;
                    z-index: 1;
                }

                .mazing-threed-btn-text,
                .mazing-ar-btn-text {
                    color: white;
                }

                .mazing-threed-btn::before,
                .mazing-ar-btn::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.15);
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform 0.3s ease;
                    z-index: -1;
                }

                .mazing-threed-btn:hover::before,
                .mazing-ar-btn:hover::before {
                    opacity: 1 !important;
                    transform: scaleX(1);
                }
            `,
            placementSelector: PLACEMENT_SELECTOR,
            threedBtn: {
                enabled: true,
                icon: true,
                customText: getButtonText({
                    en: 'View in 3D',
                    de: 'In 3D ansehen',
                    fr: 'Voir en 3D',
                    es: 'Ver en 3D'
                })
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: getButtonText({
                    en: 'View in Room',
                    de: 'Im Raum anzeigen',
                    fr: 'Voir dans votre espace',
                    es: 'Ver en tu espacio'
                })
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

const bindOptionListeners = () => {
    if (optionsListenerAttached) return;

    document.addEventListener('change', (event) => {
        const input = event.target;

        if (!input.matches(COLOR_INPUT_SELECTOR)) {
            return;
        }

        console.log('Selected color:', input.value);

        scheduleStableRefresh();
    });

    optionsListenerAttached = true;
    console.log('Option listeners attached.');
};

const observeGalleryChanges = () => {
    if (galleryObserver) {
        galleryObserver.disconnect();
    }

    const productSection =
        document.querySelector('product-info') ||
        document.querySelector('main') ||
        document.body;

    if (!productSection) {
        console.warn('No product section found for observer.');
        return;
    }

    let observerTimeout = null;

    galleryObserver = new MutationObserver(() => {
        clearTimeout(observerTimeout);

        observerTimeout = setTimeout(() => {
            const placement = document.querySelector(PLACEMENT_SELECTOR);
            const hasButton = document.querySelector('.mazing-button-container');

            if (!placement) {
                return;
            }

            if (!hasButton && lastRequestedSKU) {
                console.log('Mazing button disappeared. Restoring...');
                refreshMazingSKU('observer-restore');
            }
        }, 250);
    });

    galleryObserver.observe(productSection, {
        childList: true,
        subtree: true
    });

    console.log('Gallery observer attached.');
};

const initializeScript = async () => {
    if (initializing) return;

    initializing = true;

    try {
        await waitForMazingFunction;

        console.log('Mazing function is available.');

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();

        lastRequestedSKU = getCurrentSKU();

        bindOptionListeners();
        observeGalleryChanges();

        console.log('Mazing initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    } finally {
        initializing = false;
    }
};

initializeScript();